import Link from 'next/link';
import React from 'react';
import { isBrowser, isMobileOnly, isTablet } from 'react-device-detect';
import { HomeProps } from '../../pages';
import DefaultWidthContainer from '../Layout/Containers/DefaultWidthContainer';
import FullWidthContainer from '../Layout/Containers/FullWidthContainer';
import PageHeaderComponent from '../util/PageHeader/PageHeaderComponent';
import styles from './home.module.scss';
import LaunchNewServicesComponent from '../LaunchNewServices/LaunchNewServicesComponent';
import TrustedByComponent from '../TrustedBy/TrustedByComponent';
import InsightsComponent from '../Insights/InsightsComponent';
import CustomerCasesComponent from '../CustomerCases/CustomerCasesComponent';

const HomeComponent = ({ works, resources }: HomeProps) => {
    return (
        <>
            <LaunchNewServicesComponent />
            <section className={styles.homepage}>
                <h1 className="screen-reader-only">Noria.no frontpage</h1>
                <div className={styles.backgroundVideoContainer}>
                    {(isTablet || isBrowser) && (
                        <video
                            className={`${styles.backgroundVideo}`}
                            autoPlay
                            loop
                            muted
                            playsInline
                        >
                            <source src="/videos/bg-gradient-desktop.mp4" type="video/mp4" />
                        </video>
                    )}

                    {isMobileOnly && (
                        <video
                            className={`${styles.backgroundVideo}`}
                            autoPlay
                            loop
                            muted
                            playsInline
                        >
                            <source src="/videos/bg-gradient-mobile.mp4" type="video/mp4" />
                        </video>
                    )}
                </div>
                <FullWidthContainer>
                    <PageHeaderComponent quote="Noria helps financial institutions strengthen operations, manage change and deliver transformation through software products and specialist services.">
                        <h1>Technology and expertise for financial institutions</h1>
                    </PageHeaderComponent>
                    <DefaultWidthContainer extraClassNames={styles.linksContainer}>
                        <div className={styles.links}>
                            <Link href="/solutions" className="nv-buton nv-button-primary">
                                <span>Explore products</span>
                                <span aria-hidden="true">&#10132;</span>
                            </Link>
                            <Link href="/services" className="nv-buton nv-button-secondary">
                                <span>Explore services</span>
                                <span aria-hidden="true">&#10132;</span>
                            </Link>
                        </div>
                    </DefaultWidthContainer>
                    <TrustedByComponent />

                    <CustomerCasesComponent works={works} />

                    <InsightsComponent resources={resources} />
                </FullWidthContainer>
            </section>
        </>
    );
};

export default HomeComponent;
